'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _json2mq = require('json2mq');

var _json2mq2 = _interopRequireDefault(_json2mq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createMediaQueries = function createMediaQueries(mediaSpec) {
  return Object.keys(mediaSpec).map(function (key) {
    var stringMediaQuery = _typeof(mediaSpec[key]) === 'object' ? (0, _json2mq2.default)(mediaSpec[key]) : mediaSpec[key];
    var mdl = window.matchMedia(stringMediaQuery);
    return {
      key: key,
      initialValue: mdl.matches,
      subscribe: function subscribe(onChange) {
        var handler = function handler(e) {
          onChange(_defineProperty({}, key, e.matches));
        };
        mdl.addListener(handler);
        return function () {
          return mdl.removeListener(handler);
        };
      }
    };
  });
};

var initialState = function initialState(queries) {
  return queries.reduce(function (state, query) {
    state[query.key] = query.initialValue;
    return state;
  }, {});
};

var createMediaSubscription = function createMediaSubscription(mediaSpec) {
  return {
    subscribe: function subscribe(onMediaChange) {
      var queries = createMediaQueries(mediaSpec);
      onMediaChange(initialState(queries));
      var unsubscribes = queries.map(function (query) {
        return query.subscribe(onMediaChange);
      });
      return function () {
        unsubscribes.forEach(function (fn) {
          return fn();
        });
      };
    }
  };
};

exports.default = function (mediaSpec) {
  return function (WrappedComponent) {

    var subscription = createMediaSubscription(mediaSpec);

    var ResponsiveComponent = function (_React$Component) {
      _inherits(ResponsiveComponent, _React$Component);

      function ResponsiveComponent() {
        _classCallCheck(this, ResponsiveComponent);

        return _possibleConstructorReturn(this, (ResponsiveComponent.__proto__ || Object.getPrototypeOf(ResponsiveComponent)).apply(this, arguments));
      }

      _createClass(ResponsiveComponent, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _this2 = this;

          this.unsubscribe = subscription.subscribe(function (s) {
            return _this2.setState(s);
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.unsubscribe();
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.state, this.props));
        }
      }]);

      return ResponsiveComponent;
    }(_react2.default.Component);

    return ResponsiveComponent;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-media-hoc/lib/index.js
// module id = 194
// module chunks = 0